module.exports = __webpack_public_path__ + "static/grundriss_mobilitat-942b4dcca50bf62f7fa367bf488b002a.png";